import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
const MAX_WIDTH = 1192;
/**
 * AnnouncementContainer
 */
export const AnnouncementContainerStyles = ({ theme }) => css `
	color: ${theme.colors.blanc.textInverse};
	background: ${theme.colors.base.bgFooter};
`;
export const AnnouncementContainer = styled.div `
	${AnnouncementContainerStyles}
`;
/**
 * AnnouncementInner
 */
export const AnnouncementInnerStyles = ({ theme }) => css `
	padding: ${pxToRem(theme.spacing['400'])};
	max-width: ${pxToRem(MAX_WIDTH)};
	margin: 0 auto;
	display: flex;
	align-items: center;
	gap: ${pxToRem(theme.spacing['200'])};

	.PONCHO-typography {
		max-width: 100%;
		color: ${theme.colors.blanc.textInverse};

		&:only-child {
			margin: 0;
		}
	}
`;
export const AnnouncementInner = styled.div `
	${AnnouncementInnerStyles}
`;
//# sourceMappingURL=announcement.styled.js.map